module.exports = __webpack_public_path__ + "media/images/area/feature/setouchi/05-9bf9e16bbf68b52a023a3da48b7e53fb.jpg";